import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../hooks";

interface ProtectedComponentProps {
  allowedRoles: string[];   // e.g. ["Admin", "Manager"]
  children: React.ReactNode;
}

const ProtectedComponent: React.FC<ProtectedComponentProps> = ({
  allowedRoles,
  children,
}) => {
  const user = useAppSelector((state) => state.auth.user);

  // If no user found (not logged in)
  if (!user) {
    return <Navigate to="login" replace />;
  }

  // const userRole = user.main_role;
  const activeRole = useAppSelector((state) => state.auth).activeRole;
  // const assignedRoles = user.roles;

  // console.log("Assigned roles: ", assignedRoles);

  // If user's role is not in the allowed list
  if (!allowedRoles.includes(activeRole ?? "")) {
    return;
  }

  // ✅ Authorized
  return children;
};

export default ProtectedComponent;
